import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enHowToDelete from "./locales/en/howToDelete.json";
import enPrivacyPolicy from "./locales/en/privacyPolicy.json";
import frHowToDelete from "./locales/fr/howToDelete.json";
import frPrivacyPolicy from "./locales/fr/privacyPolicy.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        howToDelete: enHowToDelete,
        privacyPolicy: enPrivacyPolicy,
      },
      fr: {
        howToDelete: frHowToDelete,
        privacyPolicy: frPrivacyPolicy,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;